import api from '../tools/api';

export const createKp = params => api.request(
    'kp',
    'create-kp',
    params
);
